import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import { IconProps } from 'app/views/ProtectedPage/views/LeftSideBar/PortalMenu/MenuItems/types';

export const SubscriptionSVG = (props: IconProps) => {
    return <DonutLargeIcon {...props} />
}